
import InputNumber from 'primevue/inputnumber'
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'
import {
  getCurrentInstance,
  onMounted,
  ref,
  toRefs
} from 'vue'
import apiUseCase from '@/usecase/apiUseCase'
import { useStore } from 'vuex'
import { isNull } from 'lodash'
import { useRouter } from 'vue-router'
import rupiahFormat from '@/utils/helpers/rupiahFormat'

export default {
  components: {
    Dialog,
    // Form,
    // Field,
    // FieldArray,
    InputNumber,
    Button
  },
  props: {
    trxId: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: false
    },
    ritId: {
      type: String,
      default: ''
    }
  },
  emits: ['hideDialogUpdateExpense', 'reloadData'],
  setup(props: any, { emit }: any) {
    const app = getCurrentInstance()
    const {
      $toast
    } = app?.appContext.config.globalProperties || {}
    const store = useStore()
    const router = useRouter()
    const isLoading = ref(true)
    const { show, trxId, ritId } = toRefs(props)
    const showModal = show.value
    const dataSource = ref([]) as any
    const dataSourceTemp = ref([]) as any
    const dataLatestRevision = ref() as any
    const TrxId = trxId.value
    const dataForm = ref([]) as any
    const disableExpenses = ref([]) as any
    const solarBonExpense = ref<any>(null)

    const endpoint = '/transaction/v1/TransactionPp/Expense-Trx'
    const endpointExpenseRevision = '/transaction/v1/RitExpenseRevision'

    const getLatestRevision = () => {
      apiUseCase.get(`${endpointExpenseRevision}/Latest-Revision/${ritId.value}`).then((response) => {
        dataLatestRevision.value = response.result?.Items || []
        const reversedTemp = [...dataSourceTemp.value].reverse()

        if (dataLatestRevision.value.length > 0) {
          dataSource.value = reversedTemp.map((tempItem: any) => {
            const revisionItem = dataLatestRevision.value.find((rev: any) => rev.ExpenseName === tempItem.type)
            return {
              ritExpenseId: tempItem.ritExpenseId,
              type: tempItem.type,
              nominal: revisionItem ? revisionItem.RevisiAmount : tempItem.nominal
            }
          })

          if (solarBonExpense.value) {
            const solarBonRevision = dataLatestRevision.value.find((rev: any) => rev.ExpenseName === 'Solar Bon')
            if (solarBonRevision) {
              solarBonExpense.value.nominal = solarBonRevision.RevisiAmount
            }
          }
        } else {
          dataSource.value = reversedTemp
        }
      })
    }

    const getDetail = () => {
      store.dispatch('showLoading')
      apiUseCase.get(`${endpoint}/${trxId.value}`).then((response) => {
        // dataSource.value = response.result
        const dataTemp = response.result.Rits?.filter((x: any) => x.Id === ritId.value)

        const solarBonData = dataTemp[0].RitExpenses.find((x: any) => x.ExpenseName === 'Solar Bon')
        solarBonExpense.value = solarBonData ? {
          ritExpenseId: solarBonData.Id,
          type: solarBonData.ExpenseName,
          nominal: solarBonData.Nominal,
        } : null

        dataSourceTemp.value = dataTemp[0].RitExpenses.filter((x: any) => x.ExpenseName !== 'Solar Bon').map((x: any) => ({
          ritExpenseId: x.Id,
          type: x.ExpenseName,
          nominal: x.Nominal,
        }))
        getLatestRevision()
        isLoading.value = false
        store.dispatch('hideLoading')
      }).catch(() => {
        isLoading.value = false
        store.dispatch('hideLoading')
      })
    }

    const isExpenseDisabled = (currentData: string) => !disableExpenses.value.includes(currentData)

    const closeDialog = () => {
      emit('hideDialogUpdateExpense')
    }

    const onSubmitConfirmation = async (val: any = '') => {
      try {
        // Submit generic expenses
        const { error, message } = await apiUseCase.postOrPut(`${endpointExpenseRevision}`, null, dataForm.value)

        if (error) {
          throw new Error(message)
        }

        $toast.add({
          severity: 'success',
          // summary: 'Berhasil melakukan Approve Setoran',
          detail: 'Berhasil menyimpan pengeluaran',
          group: 'bc',
          closable: false,
          life: 3000
        })
        store.dispatch('setReloadDataList')
        emit('reloadData')
        closeDialog()
      } catch (err: any) {
        $toast.add({
          severity: 'error',
          // summary: '',
          detail: err.message || 'Terjadi kesalahan saat menyimpan',
          group: 'bc',
          closable: false,
          life: 3000
        })
      } finally {
        store.dispatch('hideLoading')
      }
    }

    const onSubmit = () => {
      store.dispatch('showLoading')
      dataForm.value = []

      // eslint-disable-next-line array-callback-return
      dataSource.value.map((x: any) => {
        if (isNull(x.nominal)) {
          x.nominal = 0
        }
        const formTemp = {
          ritExpenseId: x.ritExpenseId,
          ritId: ritId.value,
          nominal: x.nominal,
          verbatim: null
        }
        dataForm.value.push(formTemp)
      })

      if (solarBonExpense.value) {
        dataForm.value.push({
          ritExpenseId: solarBonExpense.value.ritExpenseId,
          ritId: ritId.value,
          nominal: solarBonExpense.value.nominal ?? 0,
          verbatim: null
        })
      }

      onSubmitConfirmation()
    }

    onMounted(() => {
      getDetail()
    })

    return {
      isLoading,
      showModal,
      closeDialog,
      dataSource,
      onSubmit,
      TrxId,
      isExpenseDisabled,
      rupiahFormat
    }
  }
}
